export default __webpack_public_path__ + "static/media/spiderwebbig_trans.f4ae71f3.png";